import  { Component } from 'react';



class Resume extends Component {



  getRandomColor() {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    if (!this.props.data) return null;

    const education = this.props.data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3>{education.school}</h3>
          <p className="info">
            {education.degree} <span>&bull;</span>
            <em className="date">{education.graduated}</em>
          </p>
          <p>{education.description}</p>
        </div>
      );
    });

    const work = this.props.data.work.map(function (work) {
      return (
        <div key={work.company}>
          <h3>{work.company}</h3>
          <p className="info">
            {work.title}
            <span>&bull;</span> <em className="date">{work.years}</em>
          </p>
          <p>{work.description}</p>
        </div>
      );
    });

    const work2 = this.props.data.work2.map(function (work2) {
      return (
        <div key={work2.company}>
          <h3>{work2.company}</h3>
          <p className="info">
            {work2.title}
            <span>&bull;</span> <em className="date">{work2.years}</em>
          </p>
          <p>{work2.description}</p>
        </div>
      );
    });

    const roomHire = this.props.data.roomHire.map(function (roomHire) {
      return (
        <div key={roomHire.company}>
          <h3>{roomHire.company}</h3>
          <p className="info">
            {roomHire.title}
            <span>&bull;</span> <em className="date">{roomHire.price}</em>
          </p>
          <p>{roomHire.description}</p>
        </div>
      );
    });

    return (
      <section id="services">
      


    
          <div className="row education">
            
            <div className="three columns header-col">
              <h1>
                <span>Studio Filming</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">{education}</div>
              </div>
            </div>
             
          </div>
       
       

  
          <div className="row work">
            
            <div className="three columns header-col">
              <h1>
                <span>Room Hire</span>
              </h1>
            </div>
            <div className="nine columns main-col">{roomHire}</div>
            
          </div>
       
        
 

    
          <div className="row work">
           
            <div className="three columns header-col">
              <h1>
                <span>Add-ons</span>
              </h1>
            </div>
            <div className="nine columns main-col">{work2}</div>
            
          </div>
        

        
      </section>
    );
  }
}

export default Resume;
